import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import _ from 'lodash';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { OpenInvesColumns } from '../gridcolumns';

const OpenInves = ({ openProtPerTypes }) => {
  const openInvInfo = _.chain(openProtPerTypes).groupBy('personType').map((v, i) => ({
    id: i,
    isMandatory: _.get(_.find(v, 'isMandatory'), 'isMandatory'),
    isMultiple: _.get(_.find(v, 'isMultiple'), 'isMultiple'),
    value: _.map(v, 'perRegTypeCode')
  })).value();

  return (
    <GridTable
      tag={`${TE.ID}openinvestigators${TE.TABLE}`}
      title="OPEN Investigators"
      exportTitle={`OPEN Investigators-${useGetPathProtocol()}-OPEN Setup`}
      columns={OpenInvesColumns}
      user={GetUserFullName()}
      rows={openInvInfo}
      editable
      deletable
      filterable
      sortable
      enableToolbar
      toPdf={false}
    />
  );
};


export { OpenInves };
